<template>
  <div class="header" style="background-color: #0A2A6B; padding: 10px 0;">
    <div class="system-title">
      <img src="@/assets/image/index/logo.png" alt="Logo" class="logo">
    </div>
    <div class="menu-list">
      <div @click="toPage('index')" :class="$route.path === '/'?'menu_item':''">首页</div>
    </div>
    <div class="center" v-if="$store.getters.userId !== 0">
      <el-dropdown @command="handleCommand">
                <span class="el-dropdown-link">
                    <img style="border-radius:50%;width:45px;height:45px" :src="$store.getters.avatar">
                </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="personalCenter">
            <div class="drop-item"><i class="el-icon-user"></i>个人中心</div>
          </el-dropdown-item>
          <el-dropdown-item command="myClass">
            <div class="drop-item"><i class="el-icon-s-management"></i>我的班级</div>
          </el-dropdown-item>
          <el-dropdown-item command="myQuestion">
            <div class="drop-item"><i class="el-icon-edit"></i>我的题库</div>
          </el-dropdown-item>
          <el-dropdown-item command="myExam">
            <div class="drop-item"><i class="el-icon-notebook-1"></i>我的考试</div>
          </el-dropdown-item>
          <el-dropdown-item command="logout" divided>
            <div class="drop-item"><i class="el-icon-back"></i>退出登陆</div>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <span class="username">{{ $store.getters.nickname }}</span>
    </div>
    <div v-else><el-button @click="goToLogin">登录</el-button></div>
  </div>
</template>
<script>
export default {
    data() {
        return {
        }
    },
    methods: {
        handleCommand(command) {
            switch (command) {
                case 'personalCenter':
                    this.$router.push("/center");
                    break;
                case 'myClass':
                    this.$router.push("/myClass");
                    break;
                case 'myCourse':
                    this.$router.push("/myCourse");
                    break;
                case 'myQuestion':
                    // 题库 -- 就是一个题目练习课程
                    this.$router.push("/myQuestionCourse");
                    break;
                case 'myExam':
                    this.$router.push("/paperRecord");
                    break;
                case 'myMistakes':
                    this.$router.push("/mistake");
                    break;
                case 'logout':
                        this.$store.dispatch('user/LogOut').then(() => {
                            this.$message({
                                message: '退出成功',
                                type: 'success'
                            });
                            setTimeout(function () {
                                window.location.reload()
                            }, 1000)
                        })
                        break;
            }
            // if (command == 'a') {
            //     this.$router.push("/center")
            // } else if (command == 'b') {
            //     this.$router.push("/myTask")
            // } else if (command == 'c') {
            //     this.$router.push("/addArticle")
            // } else if (command == 'd') {
            //     this.$router.push("/myAssign")
            // } else if (command == 'e') {
            //     this.$router.push("/myArticle")
            // } else if (command == 'f') {
            //     this.$router.push("/myFavarArticle")
            // } else if (command == 'g') {
            //     this.$router.push("/myWrongAssign")
            // } else if (command == 'i') {
            //     this.$router.push("/myFavor")
            // } else if (command == 'logout') {
            //     this.$store.dispatch('user/LogOut').then(() => {
            //         this.$message({
            //             message: '退出成功',
            //             type: 'success'
            //         });
            //         setTimeout(function () {
            //             window.location.reload()
            //         }, 1000)
            //     })
            // }
        },
      toPage(name) {
        if(name === 'index') {
          this.$router.push("/")
        }
        },
        goToLogin() {
            this.$router.push('/login');
        },
    },
    created() {

    },
    mounted() {

    }
}
</script>

<style scoped>
@import url("../../assets/css/index/header.css");
</style>w
